// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","WishList":"pi_a vh_nf vh_a vh_w","WishList__items":"pi_b vh_no vh_nj vh_ow"};